import {Component, Input, OnInit} from '@angular/core';
import {
  PvRecruitmentDialogReactivateAccountComponent
} from '../../pv-recruitment-dialog-reactivate-account/pv-recruitment-dialog-reactivate-account.component';
import {PvRecruitmentService} from '../../pv-recruitment.service';
import {NbDialogService} from '@nebular/theme';
import {Router} from '@angular/router';

@Component({
    selector: 'pv-pv-recruitment-common-header',
    templateUrl: './pv-recruitment-common-header.component.html',
    styleUrls: ['./pv-recruitment-common-header.component.scss'],
    standalone: false
})
export class PvRecruitmentCommonHeaderComponent implements OnInit {
  private fbclid: string | undefined;
  public rate: string;
  public reviewsCount: string;

  constructor(private dialogService: NbDialogService,
              private router: Router,
              private recruitmentService: PvRecruitmentService) { }

  ngOnInit(): void {
    this.recruitmentService.getReviewsGlobalRate().then(res => {
      const rawRate = res.reviewsGlobalRate?.rate;
      const rawCount = res.reviewsGlobalRate?.reviewsCount;

      this.rate = Number.isInteger(rawRate)
        ? rawRate.toString()
        : rawRate.toLocaleString('fr-FR', { minimumFractionDigits: 1, maximumFractionDigits: 1 });

      this.reviewsCount = rawCount.toLocaleString('fr-FR');
    })
  }

  public showRecruitmentPage() {
    this.router.navigate(['/', 'inscription'], {
      state: {
        dialogStep: 0,
        retry: false
      }
    });
    this.recruitmentService.gaPageEvent('recruitement-dialog');
    this.recruitmentService.fbEvent('ViewContent', this.fbclid).catch(error => {
      console.error(error);
    });
  }

  public showConnexionDialog() {
    this.dialogService.open(PvRecruitmentDialogReactivateAccountComponent, {});
    this.recruitmentService.gaPageEvent('login-dialog');
  }
}
